import { render, staticRenderFns } from "./ModalSuccessMorbidity.vue?vue&type=template&id=4c74e57c"
import script from "./ModalSuccessMorbidity.vue?vue&type=script&lang=js"
export * from "./ModalSuccessMorbidity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports